import * as React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import Grid from '@mui/material/Grid';

export default function OrdemServicoItem({
  ordem,
  onChangeSelected,
  onChangeOrdem,
}) {
  const [valor, setValor] = React.useState(
    typeof ordem.valor_final === 'number' ? ordem.valor_final : 0,
  );

  const [radio, setRadio] = React.useState(ordem.ind_selecionado); //parcial ou total

  React.useEffect(() => {
    if (!ordem.checked) {
      setRadio(null);
    }
  }, [ordem.checked]);

  const onChangeRadio = (event) => {
    setRadio(event.target.value);

    if (event.target.value === 'parcial') {
      onChangeOrdem(ordem.id_ordem_compra, {
        ...ordem,
        valor_final: 0,
        ind_selecionado: event.target.value,
      });
      setValor(0);
      return;
    }

    onChangeOrdem(ordem.id_ordem_compra, {
      ...ordem,
      valor_final: parseFloat(
        ordem.saldo_ordem.includes(',')
          ? ordem.saldo_ordem.replace('.', '').replace(',', '.')
          : ordem.saldo_ordem,
      ),
      ind_selecionado: event.target.value,
    });

    setValor(parseFloat(ordem.saldo_ordem));
  };

  const converToFloat = (currency) => {
    let result = String(currency).split('.').join('');
    result = result.replace(',', '.');

    var value = parseFloat(result);
    return value.toFixed(2);
  };

  const getMaxValue = () => {
    const currency = ordem.saldo_ordem;
    var cur_re = /\D*(\d+|\d.*?\d)(?:\D+(\d{2}))?\D*$/;
    var parts = cur_re.exec(currency);
    var number = parseFloat(
      parts[1].replace(/\D/, '') + '.' + (parts[2] ? parts[2] : '00'),
    );
    return number.toFixed(2);
  };

  return (
    <tr
      id={ordem.ordem_compra}
      style={{
        background: '#fff',
        border: '1px solid #E7F0FF',
      }}
    >
      <td style={{ width: '2 %' }}>
        <Box>
          <FormControlLabel
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              alignItems: 'center',
            }}
            control={
              <Checkbox
                checked={ordem.checked}
                onChange={(event) => onChangeSelected(ordem.id_ordem_compra)}
              />
            }
          />
        </Box>
      </td>
      <td style={{ width: '15%', color: '#0e72b8', fontSize: '0.84rem' }}>
        {ordem.id_ordem_compra}
      </td>
      <td style={{ width: '20%', fontSize: '0.84rem' }}>
        {ordem && ordem.descricao}
      </td>
      <td style={{ width: '50%', fontSize: '0.84rem' }}>
        <RadioGroup
          row
          value={radio}
          aria-labelledby="demo-row-radio-buttons-group-label"
          onChange={onChangeRadio}
          name="row-radio-buttons-group"
        >
          <Grid container spacing={2}>
            <Grid container sm={6} item justifyContent={'flex-end'}>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                <FormControlLabel
                  value="total"
                  disabled={!ordem.checked}
                  control={<Radio size="small" />}
                  label={
                    <span style={{ marginRight: 5, fontSize: '0.84rem' }}>
                      Valor Total: R$ {ordem.saldo_ordem}
                    </span>
                  }
                />
              </Box>
            </Grid>
            <Grid container sm={6} item justifyContent={'flex-end'}>
              <FormControlLabel
                value="parcial"
                disabled={!ordem.checked}
                control={<Radio size="small" />}
                label={
                  <Box
                    display={'inline-flex'}
                    alignItems="center"
                    justifyContent={'center'}
                  >
                    <span style={{ marginRight: 5, fontSize: '0.84rem' }}>
                      Outro valor:
                    </span>
                    <CurrencyTextField
                      label="R$"
                      size="small"
                      variant="outlined"
                      value={radio !== 'parcial' ? 0 : valor}
                      style={{ width: 135 }}
                      decimalCharacter=","
                      digitGroupSeparator="."
                      minimumValue={'0'}
                      maximumValue={getMaxValue()}
                      currencySymbol=""
                      disabled={!ordem.checked || radio !== 'parcial'}
                      onChange={(event) => {
                        if (
                          converToFloat(event.target.value) >
                          parseFloat(getMaxValue())
                        ) {
                          setValor(parseFloat(getMaxValue()));
                        } else {
                          setValor(
                            parseFloat(converToFloat(event.target.value)),
                          );
                          if (!event.target.value) {
                            onChangeOrdem(ordem.id_ordem_compra, 0, radio);
                            return;
                          }

                          onChangeOrdem(ordem.id_ordem_compra, {
                            ...ordem,
                            valor_final: parseFloat(
                              converToFloat(event.target.value),
                            ),
                          });
                        }
                      }}
                    />
                  </Box>
                }
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </td>
    </tr>
  );
}
